import { composeIO } from 'react-compose-io'
import { inputPesquisaIO } from './InputPesquisa.IO'
import InputPesquisaView from './InputPesquisa.View'

const InputPesquisa = composeIO(InputPesquisaView, inputPesquisaIO)

export default InputPesquisa
